import { graphql, navigate, useStaticQuery } from "gatsby";
import queryString from "query-string";
import { useLocation } from "@reach/router";
import React, { useEffect, useRef, useState } from "react";

export const Navigation: React.FC = (props) => {
  const data: Queries.NavigationMenuQuery = useStaticQuery(graphql`
    query NavigationMenu {
      strapiGlobalContent {
        header_menu_items {
          id
          alt_text
          # // article part is removed because there are no entries with data
          # // cf. this gatsby strapi quirk: https://www.gatsbyjs.com/plugins/gatsby-source-strapi/#restrictions-and-limitations
          # article {
          #   slug
          # }
          url
          label
        }
      }
    }
  `);
  const [searchQuery, setSearchQuery] = useState<string>();
  const [isSearchShown, setIsSearchShown] = useState(false);
  const startScrollPositionRef = useRef(0);
  const isScrollingRef = useRef<any>(null);
  const location = useLocation();
  useEffect(() => {
    // console.log(queryString.parse(location.search));
    const { q } = queryString.parse(location.search);
    setSearchQuery(q ? (Array.isArray(q) ? q.join(" ") : q) : undefined);
  }, [location]);
  const scrollYRef = useRef<null | number>(null);
  const [hideHeader, setHideHeader] = React.useState(false);
  useEffect(() => {
    const scrollFunc = () => {
      if (isScrollingRef.current) {
        window.clearTimeout(isScrollingRef.current);
      } else {
        startScrollPositionRef.current = window.scrollY;
      }
      isScrollingRef.current = setTimeout(function () {
        if (window.scrollY > startScrollPositionRef.current) {
          setHideHeader(true);
        } else {
          setHideHeader(false);
        }
        isScrollingRef.current = null;
      }, 120);
    };
    window.addEventListener("scroll", scrollFunc);
    return () => {
      window.removeEventListener("scroll", scrollFunc);
    };
  }, []);
  const submitSearch = () => {
    navigate(`/search?q=${encodeURIComponent(searchQuery || "")}`);
  };
  const translateClass = hideHeader ? "-translate-y-24" : "translate-y-0";
  return (
    <div
      className={`fixed left-[-1px] right-[-1px] top-0 z-20 flex h-20 transition-transform duration-1000 lg:h-20 ${translateClass}`}
    >
      <div className="flex w-8 items-end rounded-br-md border-b  border-r border-beige bg-light-gray px-4 pt-4 lg:w-auto lg:flex-1 lg:rounded-br-2xl "></div>
      <div className="flex max-w-[8rem] content-center  items-center rounded-b-md border-x border-b border-purple bg-purple px-5 py-1 lg:max-w-[16rem] lg:rounded-b-2xl lg:px-12 lg:py-5">
        <a href="/" className="w-full">
          <img src="/images/logo1.png" alt="" className="w-full" />
        </a>
      </div>
      <div className="mr-[-1px] hidden items-end rounded-b-md  border-x border-b border-beige bg-light-gray px-4 pb-4 lg:flex lg:rounded-b-2xl">
        <a href="/">
          <div className="font-serif text-lg">Living Media Art</div>
        </a>
      </div>
      <div className="flex flex-[2_2_0%] items-center justify-end rounded-b-md border-x border-b border-beige bg-light-gray px-4 lg:items-end lg:rounded-b-2xl lg:pb-4">
        <nav>
          <ul className="flex gap-4 text-reg  sm:text-m ">
            {data.strapiGlobalContent?.header_menu_items &&
              data.strapiGlobalContent.header_menu_items
                .filter((item) => !!item)
                .map((item) =>
                  item ? (
                    <li key={item.id}>
                      <a
                        title={item!.alt_text || ""}
                        href={
                          item!.article
                            ? `/article/${item?.article?.slug}`
                            : item!.url
                            ? item.url
                            : "#"
                        }
                      >
                        {item!.label}
                      </a>
                    </li>
                  ) : null,
                )}
          </ul>
        </nav>
      </div>
      <div
        className={`
        absolute
        right-0
        ml-[-1px]
        h-20
        items-center
        rounded-b-md
        border-x
        border-b
        border-beige
        bg-light-gray
        px-4
        lg:static
        lg:flex
        lg:h-auto
        lg:items-end
        lg:rounded-b-2xl
        lg:pb-4
        ${isSearchShown ? "flex" : "hidden"}
      `}
      >
        <input
          className="relative  ml-2 h-8 border border-beige bg-light-gray px-3 text-sm placeholder-beige lg:w-52"
          placeholder="Search website..."
          type="text"
          name=""
          id=""
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onSubmit={() => submitSearch()}
          onKeyDown={(e) => {
            if (e.key == "Enter") {
              submitSearch();
            }
          }}
        />
        <div
          onClick={() => submitSearch()}
          className="h-7 cursor-pointer border-beige  px-2 py-1 lg:h-8"
        >
          <img className="h-full" src="/images/magnifying-glass.png" alt="" />
        </div>
      </div>
      <div className="ml-[-1px] flex items-center rounded-b-md border-x border-b border-beige bg-light-gray px-4 lg:hidden">
        <div
          onClick={() => setIsSearchShown((show) => !show)}
          className="h-7 cursor-pointer  border-beige px-2 py-1"
        >
          <img className="h-full" src="/images/magnifying-glass.png" alt="" />
        </div>
      </div>
    </div>
  );
};
